  import {colorMapsFromMinMaxFactory} from "../../utils/color-maps";

const adaptation_future_color = (adaptation) => {
  if (adaptation == 'cla_1') return '#66c2a5'
  if (adaptation == 'ews_1') return '#fc8d62'
  if (adaptation == 'rws_1') return '#8da0cb'
  if (adaptation == 'rws_2') return '#e78ac3'
  if (adaptation == 'ews_2') return '#a6d854'
  if (adaptation == 'ews_3') return '#ffd92f'
  if (adaptation == 'ews_5') return '#e5c494'
  if (adaptation == 'ews_6') return '#b3b3b3'
}


const adaptationFutureLegend = [
  {color: '#66c2a5', text: 'cla_1'},
  {color: '#fc8d62', text: 'ews_1'},
  {color: '#8da0cb', text: 'rws_1'},
  {color: '#e78ac3', text: 'rws_2'},
  {color: '#a6d854', text: 'ews_2'},
  {color: '#ffd92f', text: 'ews_3'},
  {color: '#e5c494', text: 'ews_5'},
  {color: '#b3b3b3', text: 'ews_6'},
]

const adaptationDefaults = {
  url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/kent/investment-future/adaptation_optimizations.zip',
  title: 'Adaptation future',
  legend: adaptationFutureLegend
}

const hazardDefaults = {
  pixelValuesToColorFn: (([value]) => {
    if (value > 1) return `rgba(0,0,0,0)`;

    if (value >= 0.2) return '#08306b';
    if (value >= 0.1) return '#08519c';
    if (value >= 0.066) return '#2171b5';
    if (value >= 0.05) return '#4292c6';
    if (value >= 0.02) return '#6baed6';
    if (value >= 0.01) return '#9ecae1';
    if (value >= 0.0001) return '#c6dbef';
    
    return `rgba(0,0,0,0)`;
  }),
  opacity: 1,
  legend: [
    {color: '#c6dbef', text: '< 0.01'},
    {color: '#9ecae1', text: '0.01 - 0.02'}, //
    {color: '#6baed6', text: '0.02 - 0.05'}, //
    {color: '#4292c6', text: '0.05 - 0.066'},
    {color: '#2171b5', text: '0.066 - 0.1'},
    {color: '#08519c', text: '0.1 - 0.2'},
    {color: '#08306b', text: '> 0.2'},
  ],
  zIndex: 420
}
const Hazards = []


const getHazardUrl = (source, depth) => {
  const prefix = 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/flood_hazard/'
  return prefix +  source + '_pd_maintain_probability_extents_' + depth + 'm_with_global_surface_water_cogeo.tif'
}

let idx = 0;

['f', 'c', 'sw', 'cf'].forEach(source => {
  [0.1].forEach(depth => {
    Hazards.push({
      id: idx,
      key: idx,
      ...hazardDefaults,
      name: source + '_' + 'pd_maintain_' + depth,
      text: source.toUpperCase() + ' - Present Day',
      url: getHazardUrl(source, depth),
      source: source,
      depth_threshold: depth,
      title: `Annual probability of exceedence (${depth}m flood depth)`
    })  
    idx = idx + 1;
  })
})



export default   {
  sectionText: 'Present Day Flood Hazards (undefended)',
  section: 'flood_hazard',
  components: [
    {
      text: 'Source',
      type: 'select',
      stateProperty: 'source',
      options: [
        {key:1, text: 'Fluvial', value: 'f'},
        {key: 2, text: 'Coastal', value: 'c'},
        {key: 3, text: 'Surface water', value: 'sw'},
        {key: 4, text: 'Max Coastal,Fluvial', value: 'cf'}
      ],
      initialState: 'f'
    },
    {
      text: 'Depth threshold (m)',
      type: 'select',
      stateProperty: 'depth_threshold',
      options: [
        {key:1, text: '0.1', value: 0.1}
      ],
      initialState: null
    },
    {
      text: 'Flood Hazard',
      type: 'hidden',
      stateProperty: 'flood_hazard',
      initialState: null,
      layerType: 'select-rasterfile',
      filter: (hazard, sectionState) => {
        return hazard.source == sectionState.source && hazard.depth_threshold == sectionState.depth_threshold
      },
      allOptions: Hazards.map(area => ({
        key: area.name,
        id: area.name,
        text: area.text,
        value: area.name,
        source: area.source,
        depth_threshold: area.depth_threshold,
        url: area.url
      })),
      rasterfiles: Hazards
    },

  ]
}